const MAX_LENGTH_PLATE_NUMBER = 7;
const MIN_BELGIAN_LENGTH_PLATE_NUMBER = 1;
const MAX_BELGIAN_LENGTH_PLATE_NUMBER = 8;

const onlyLettersAndNumbers = (str) => /^[A-Za-z0-9]*$/.test(str);

const plateNumberFormat = (str) =>
  onlyLettersAndNumbers(str) ? str.toUpperCase() : str.slice(0, -1);

export {
  MAX_LENGTH_PLATE_NUMBER,
  MIN_BELGIAN_LENGTH_PLATE_NUMBER,
  MAX_BELGIAN_LENGTH_PLATE_NUMBER,
  plateNumberFormat
};
